import { RefObject, useEffect } from "react";
import { EmailThreadSortOrder } from "@/components/molecules/email";

const isScrollable = (el: HTMLElement): boolean => {
	const { overflowY } = window.getComputedStyle(el);
	return (overflowY === "auto" || overflowY === "scroll") && el.scrollHeight > el.clientHeight;
};

// The ref points to the outer conversationContainer, but the actual scroll container is the
// inner FluentProvider div (overflow: hidden auto, height: 100%). Walk direct children to find it.
const getScrollableContainer = (container: HTMLElement): HTMLElement => {
	if (isScrollable(container)) {
		return container;
	}
	for (const child of container.children) {
		const childEl = child as HTMLElement;
		if (isScrollable(childEl)) {
			return childEl;
		}
	}
	return container;
};

export const useScrollEmailConversationToBottom = (
	scrollRef: RefObject<HTMLDivElement>,
	sortOrder: EmailThreadSortOrder,
	emailsLength: number
): void => {
	useEffect(() => {
		if (!scrollRef.current) {
			return;
		}
		const el = getScrollableContainer(scrollRef.current);
		el.scrollTop = sortOrder === "oldest-first" ? el.scrollHeight : 0;
	}, [sortOrder, emailsLength, scrollRef]);
};
